import { render, staticRenderFns } from "./ContractsTable.vue?vue&type=template&id=01b1164c&scoped=true"
import script from "./ContractsTable.vue?vue&type=script&lang=js"
export * from "./ContractsTable.vue?vue&type=script&lang=js"
import style0 from "./ContractsTable.vue?vue&type=style&index=0&id=01b1164c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b1164c",
  null
  
)

export default component.exports